module.exports = __webpack_public_path__ + "img/Icon-upload.da67e1ba.svg";